import script from "./DialogBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogBox.vue?vue&type=script&setup=true&lang=ts"

import "./DialogBox.vue?vue&type=style&index=0&id=739a27ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739a27ec"]])

export default __exports__